<template>
  <div class="page">
    <BackNav :title="$t('changePassword.title')" />
    <div class="form-card">
      <van-form @submit="onSubmit">
        <div class="field-wrap">
          <div class="field-label">{{ $t('changePassword.oldPassword') }}</div>
          <van-field
            v-model="oldPassword"
            type="password"
            name="oldPassword"
            :placeholder="$t('changePassword.oldPasswordPlaceholder')"
            :rules="[{ required: true, message: $t('changePassword.oldPasswordPlaceholder') }]"
            :border="false"
          />
        </div>
        <div class="field-wrap">
          <div class="field-label">{{ $t('changePassword.password') }}</div>
          <van-field
            v-model="password"
            type="password"
            name="password"
            :placeholder="$t('changePassword.passwordPlaceholder')"
            :rules="[{ required: true, message: $t('changePassword.passwordPlaceholder') }]"
            :border="false"
          />
        </div>
        <div class="field-wrap">
          <div class="field-label">{{ $t('changePassword.confirmPassword') }}</div>
          <van-field
            v-model="confirmPassword"
            type="password"
            name="confirmPassword"
            :placeholder="$t('changePassword.confirmPasswordPlaceholder')"
            :rules="[{ required: true, message: $t('changePassword.confirmPasswordPlaceholder') }]"
            :border="false"
          />
        </div>
        <van-button round block class="brand-btn submit-btn" :loading="loading" native-type="submit">
          {{ $t('common.confirm') }}
        </van-button>
      </van-form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import BackNav from '@/components/BackNav';
import { useRouter } from 'vue-router';
import { Toast } from 'vant';
import { UserService } from '@/services';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const oldPassword = ref('');
const password = ref('');
const confirmPassword = ref('');
const loading = ref(false);
const router = useRouter();
const onSubmit = async () => {
  if (password.value !== confirmPassword.value) {
    Toast(t('changePassword.passwordMismatch'));
    return;
  }
  loading.value = true;
  const { code } = await UserService.modifyPasswordApi({
    oldPassword: oldPassword.value,
    password: password.value,
  });
  loading.value = false;
  if (code === 0) {
    router.go(-1);
  }
};
</script>

<style lang="scss" scoped>
.page {
  min-height: 100vh;
  background: var(--bg-page);
}
.form-card {
  margin: 24px 20px;
  background: #fff;
  border-radius: 24px;
  padding: 40px 32px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
}
.field-wrap {
  margin-bottom: 24px;
  .field-label {
    font-size: 26px;
    color: var(--text-secondary);
    margin-bottom: 12px;
    font-weight: 500;
  }
  :deep(.van-cell) {
    background: #f5f7fa;
    border-radius: 16px;
    padding: 24px 28px;
    font-size: 30px;
    &::after {
      display: none;
    }
  }
  :deep(.van-field__control) {
    color: var(--text-primary);
    font-size: 30px;
    &::placeholder {
      color: #a0aec0;
    }
  }
}
.submit-btn {
  height: 96px !important;
  margin-top: 32px !important;
  font-size: 32px !important;
}
</style>
